<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getDepartments");

  },
  computed: {
    departments() {
      return  this.$store.state.lookups.departments;

    }
  },
  data() {
    return {
      vm: {
        fullName: null,
        jobDescription: null,
        departmentId: null,
        phoneNo: null,
      },
    };
  },
  methods: {
    
    onFileUpload(file) {
      // Handle the file upload logic here
      console.log("File uploaded:", file);
    },
    confirm() {
      this.$store
        .dispatch("employees/add",  this.vm )
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>